<template>
    <div class="-mt-md sm:mt-0" ref="weekmenucontainer">
        <div key="loading" class="flex justify-center" v-if="loading">
            <div class="aspect-[320/520] w-1/4 relative mb-sm sm:mb-md flex justify-center items-center">
                <i class="fa-regular fa-spinner-third h-[60px] w-auto animate-spin"></i>
            </div>
        </div>
        <div v-else class="grid gap-y-lg sm:gap-x-md grid-cols-12">
            <div v-for="item in weekmenus" :key="item.id" class="col-span-12 xs:col-span-4">
                <weekmenuitem :content="item" />
            </div>

            <div class="col-span-12">
                <pagination :current-page="currentPage" :total-pages="totalPages" @next-page="filter(currentPage + 1)" @previous-page="filter(currentPage - 1)" @go-to-page="(event) => filter(event.page)"> </pagination>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import weekmenuitem from './item';
import { debounce } from 'lodash';
import qs from 'qs';
import Vue from 'vue';
var scrollIntoView = require('scroll-into-view');

export default {
    name: 'weekmenusoverview',

    data() {
        return {
            loading: false,
            weekmenus: [],
            perPage: 12,
            totalPages: 0,
            currentPage: 1,
        };
    },

    mounted() {
        let urlParams = new URLSearchParams(window.location.search);

        this.currentPage = parseInt(urlParams.get('f') ?? 1);
        const page = parseInt(urlParams.get('p') ?? 1);

        this.getWeekmenus(page, false);
    },

    methods: {
        filter(page) {
            this.getWeekmenus(page);
        },

        getWeekmenus(page, scroll = true) {
            this.loading = true;

            if (scroll) {
                scrollIntoView(this.$refs.weekmenucontainer);
            }

            const query = this.buildQueryObject(page);
            const queryString = qs.stringify(query, { encode: false });

            axios
                .get(`/api/weekmenus?${queryString}`)
                .then((response) => {
                    if (response.status === 200) {
                        let weekmenus = response.data.data.results;
                        if (query.per_page > this.perPage) {
                            const pagesToCut = Math.ceil(weekmenus.length / this.perPage) - 1;
                            weekmenus = weekmenus.slice(pagesToCut * this.perPage);
                        }
                        if (page < this.currentPage) {
                            weekmenus = weekmenus.reverse();
                        }

                        this.setQueryParams(query, page);

                        this.weekmenus = weekmenus;
                        this.totalPages = Math.ceil(response.data.data.meta.total / this.perPage);
                        this.currentPage = page;
                    } else {
                        this.weekmenus = [];
                    }
                })
                .finally(() => (this.loading = false));
        },

        setQueryParams(query, page) {
            const searchParams = new URLSearchParams();
            if (page !== 1) {
                searchParams.set('p', page);
            }

            if (page !== 1) {
                searchParams.set('f', this.currentPage);
            }

            let newRelativePathQuery = window.location.pathname;
            let hasKeys = false;
            for (const key of searchParams.keys()) {
                hasKeys = true;
            }

            if (hasKeys) {
                newRelativePathQuery += '?' + searchParams.toString();
            }
            history.pushState(null, '', newRelativePathQuery);
        },

        buildQueryObject(page) {
            let query = {};

            query.per_page = Math.abs(page - this.currentPage) * this.perPage;
            if (query.per_page === 0) {
                query.per_page = this.perPage;
            }

            query.paginate = true;

            if (page === 1 && this.currentPage === 1) {
                return query;
            }

            if (page > this.currentPage) {
                return query;
            }

            return query;
        },
    },

    components: {
        weekmenuitem,
    },
};
</script>
